// eslint-disable-next-line import/prefer-default-export
export const Languages = {
  en_US: 1,
  en_ES: 2,
  en_AS: 3,
  vi: 4,
  pl: 5,
  ru: 6,
  ko: 7,
};

export const Month = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

export const FileUploadTypes = {
  Logo: 'Logo',
  Plan: 'Plan',
  Banner: 'Banner',
  Advanced: 'Advanced',
};
